import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import { lazyRoute } from 'utils/functions/lazyRoute';
import AuthRoute from './components/AuthRoute';
import ErrorPage from './components/ErrorPage';
import PublicRoute from './components/PublicRoute';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      {/* PUBLIC ROUTES */}
      <Route element={<PublicRoute />}>
        <Route
          path="login"
          errorElement={<ErrorPage isAuthed={false} />}
          lazy={lazyRoute(() => import('containers/Login'))}
        />
        <Route
          path="*"
          errorElement={<ErrorPage isAuthed={false} />}
          lazy={lazyRoute(() => import('containers/NotFound'))}
        />
        <Route
          path="acesso"
          errorElement={<ErrorPage isAuthed={false} />}
          lazy={lazyRoute(() => import('containers/Access'))}
        />
      </Route>

      {/* AUTHENTICATED ROUTES */}
      <Route element={<AuthRoute />}>
        <Route
          path=""
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/Dashboard'))}
        />
        <Route
          path="c5"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/DashC5'))}
        />

        <Route
          path="perfil"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/ProfilePage'))}
        />

        <Route
          path="aceite-termos"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/Terms'))}
        />

        <Route
          path="grade-unica"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/GradeUnique'))}
        />

        <Route
          path="notificacoes"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/Notifications'))}
        />

        <Route
          path="primeiro-acesso"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/FirstAccess'))}
        />

        <Route
          path="em-construcao"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/UnderConstruction'))}
        />

        <Route
          path="perfil-estudantes"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/EngagementProfile'))}
        />

        <Route
          path="centraldeconhecimento"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/KnowledgeCenter'))}
        />

        <Route
          path="recursos-formativos"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/TrainingResources'))}
        />

        <Route
          path="dashboard/:learning_path_instance_id/:dashboard_id"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(
            () => import('containers/PracticeTestReport/DashboardReport')
          )}
        />

        <Route
          path="relatorio-simulado/:learning_path_instance_id/:learning_path_state"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/PracticeTestReport'))}
        />

        <Route path="temas">
          <Route
            path=""
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/ThemesList'))}
          />
        </Route>

        <Route path="turmas">
          <Route
            path=""
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/StudentsList'))}
          />
          <Route path="estudante">
            <Route
              path=":student_id"
              errorElement={<ErrorPage />}
              lazy={lazyRoute(() => import('containers/TeacherStudentInfo'))}
            />
            <Route
              path=":student_id/alterar_senha"
              errorElement={<ErrorPage />}
              lazy={lazyRoute(
                () =>
                  import('containers/TeacherStudentInfo/TeacherStudentInfoChangePassword')
              )}
            />
          </Route>
        </Route>

        <Route path="grades">
          <Route
            path=""
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/CorrectionGrids'))}
          />
          <Route
            path=":review_grid_id"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/TeacherGradeInfo'))}
          />
        </Route>

        <Route path="evolucao">
          <Route
            path=""
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/EvolutionReport'))}
          />
          <Route
            path="impressao"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(
              () => import('containers/EvolutionReport/PrintPage')
            )}
          />
          <Route
            path="dashboard"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/EvolutionDashboard'))}
          />
        </Route>

        <Route path="recomendacoes">
          <Route
            path=""
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/Recommendations'))}
          />
          <Route
            path="tecnicos"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(
              () =>
                import('containers/TrainingResources/TechniciansRecommendations')
            )}
          />
        </Route>

        <Route path="plano-de-aula">
          <Route
            path="v2/:lesson_plan_id"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/LessonPlanV2'))}
          />
        </Route>

        <Route path="atividades">
          <Route
            path=":test_type"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/TestsListPage'))}
          />
          <Route
            path=":learning_path_type/unificado/:learning_path_instance_id/:learning_path_state/"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('containers/LearningPathReport'))}
          />
        </Route>

        <Route
          path="correcao/:composition_id"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/Review'))}
        />

        <Route
          path="socio-emocional"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(() => import('containers/SocioEmotionalDashboard'))}
        />

        <Route
          path="biblioteca"
          element={
            <iframe
              width="100%"
              height="100%"
              style={{ width: '100%' }}
              src="https://letrus-com-br-7068977.hs-sites.com/conteudos-letrus-mt-2"
              title="biblioteca letrus"
            />
          }
          errorElement={<ErrorPage />}
        />

        <Route
          path="pesquisa/:recommendation_id/:recommendation_user_instance"
          errorElement={<ErrorPage />}
          lazy={lazyRoute(
            () => import('containers/RecommendationQuestionnaire')
          )}
        />

        <Route path="v2">
          <Route
            path="home"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('pages/Home'))}
          />

          <Route path="atividades">
            <Route
              path=""
              errorElement={<ErrorPage />}
              lazy={lazyRoute(() => import('pages/LearningPathList'))}
            />

            <Route
              path=":learning_path_id"
              errorElement={<ErrorPage />}
              lazy={lazyRoute(() => import('pages/LearningPathReport'))}
            />

            <Route
              path=":learning_path_id/detalhes-questionario/:step_order"
              errorElement={<ErrorPage />}
              lazy={lazyRoute(() => import('pages/QuestionnaireDetails'))}
            />

            <Route
              path=":learning_path_id/proposta-escrita/:step_id"
              errorElement={<ErrorPage />}
              lazy={lazyRoute(() => import('pages/CompositionInstructions'))}
            />

            <Route
              path=":learning_path_id/questionario/:questionnaire_id"
              errorElement={<ErrorPage />}
              lazy={lazyRoute(() => import('pages/QuestionnaireContent'))}
            />
          </Route>

          <Route
            path="trilhas/baixar-resultados"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('pages/DownloadFeedback'))}
          />

          <Route
            path="trilhas/enviar-atividades"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(
              () => import('pages/AIUnplugged/views/SendActivities/index')
            )}
          />

          <Route
            path="trilhas/imprimir"
            errorElement={<ErrorPage />}
            lazy={lazyRoute(() => import('pages/PrintMaterials'))}
          />
        </Route>
      </Route>
    </Route>
  )
);
